/* 瀏覽器進入點。

   main.ts 本身沒有任何載入即執行的副作用（不建 renderer、不掛事件、不碰 DOM），
   所以它可以在 Node 裡被 import 來跑重播測試。真正把東西接上瀏覽器的是這一支。 */

import { boot } from './game';

boot();
